// convert a html table to a datatable (for more information go to www.datatables.net)
/**
 * Wandelt eine HTML-Tabelle in eine DataTable um.
 * Für weitere Informationen siehe: https://datatables.net
 *
 * @param {string|HTMLElement|jQuery} tableId - ID oder DOM-Element der Tabelle.
 * @param {boolean} selectable - Ob Zeilen auswählbar sein sollen.
 * @param {number} [orderByColumn] - Spaltenindex für die Sortierung.
 * @param {string} [orderType] - Sortierrichtung ('asc' oder 'desc').
 * @param {boolean} [slim] - Wenn true, wird die Tabelle kompakter dargestellt.
 * @param {number} [numberOfEntries] - Anzahl der Einträge pro Seite.
 * @param {number[]} [staticColumns] - Spalten, die nicht sortier- oder durchsuchbar sind.
 * @returns {DataTable} - Das DataTable-Objekt.
 */
function datatableMe(
    tableId,
    selectable,
    orderByColumn,
    orderType,
    slim,
    numberOfEntries,
    staticColumns
) {
    const tableSelector = typeof tableId === "string" ? $("#" + tableId) : $(tableId);
    if ($.fn.DataTable.isDataTable(tableSelector)) return tableSelector;

    orderType = orderType || "desc";
    orderByColumn = orderByColumn ?? getOrderByColumn(tableSelector);
    const pageLength = numberOfEntries || 10;
    staticColumns = staticColumns || [-1];

    registerMomentDateTypes();
    registerNullableDateSort();
    const dateColumns = detectDateColumns(tableSelector);

    const dataTableOptions = {
        columnDefs: [
            {targets: staticColumns, orderable: false, searchable: false},
            {targets: dateColumns, type: "nullable-date"}
        ],
        language: {
            decimal: ",",
            emptyTable: "Keine Einträge vorhanden.",
            info: "Seite _PAGE_ von _PAGES_",
            infoEmpty: "Keine Einträge vorhanden.",
            infoFiltered: "(gefiltert von _MAX_ Einträgen)",
            thousands: ".",
            lengthMenu: "Zeige _MENU_ Zeilen pro Seite",
            loadingRecords: "Ladet ...",
            processing: "In Arbeit ...",
            search: "Suche:",
            zeroRecords: "Keine Einträge gefunden.",
            paginate: {
                first: "Erste",
                last: "Letzte",
                next: ">",
                previous: "<"
            },
            aria: {
                sortAscending: ": aufsteigend sortieren",
                sortDescending: ": absteigend sortieren"
            },
            select: {
                rows: "%d Einträge ausgewählt"
            },
            buttons: {
                selectAll: "<span title =\"Alle auswählen\" class=\"glyphicon glyphicon-expand\"></span><span>&nbsp; Alle auswählen</span>",
                selectNone: "<span title =\"Keine auswählen\" class=\"glyphicon glyphicon-unchecked\"></span><span>&nbsp; Keine auswählen</span>"
            }
        },
        buttons: ['selectAll', 'selectNone'],
        info: false,
        select: {style: "api", info: false, select: true},
        order: [[orderByColumn, orderType]],
        fixedHeader: true,
        stateSave: true,
        stateDuration: -1,
        retrieve: true,
        drawCallback: function (settings) {
            const api = new $.fn.dataTable.Api(settings);
            const visible = settings.fnRecordsDisplay() > 0 || api.search().trim() !== "";
            datatableWrapper(settings.sTableId).toggle(visible);
            $(".deactivatedtable" + settings.sTableId).toggle(visible);

            addRowNumbers(api, tableId);
        }
    };

    if (pageLength > 0) {
        dataTableOptions.pageLength = pageLength;
        dataTableOptions.lengthMenu = [pageLength, 25, 50, 75, 100];
    } else {
        Object.assign(dataTableOptions, {
            lengthMenu: -1,
            bLengthChange: false,
            bInfo: false,
            paging: false
        });
    }

    if (slim) {
        dataTableOptions.paging = false;
        dataTableOptions.info = false;
    }

    if (!selectable) {
        dataTableOptions.select = selectable;
    }

    // Filter-Checkbox Integration
    $.fn.dataTable.ext.search.push((settings, searchData, index, rowData) => {
        try {
            const meta = $(rowData[0]);
            const drawDeactivated = $("#datatablesToggleActive" + settings.sTableId).is(":checked");
            const drawExpired = $("#datatablesToggleExpired" + settings.sTableId).is(":checked");
            if (!drawDeactivated && meta.hasClass("deactivated")) return false;
            if (!drawExpired && meta.hasClass("expired")) return false;
        } catch (_) {
        }
        return true;
    });

    const table = tableSelector.DataTable(dataTableOptions);

    // Zeilenauswahl aktivieren
    if (selectable) {
        tableSelector.on("click", "tbody tr", function () {
            const data = table.row(this).data();
            $(this).toggleClass("selected");
            const checkbox = $(this).find("input:checkbox");
            checkbox.prop("checked", !checkbox.prop("checked"));
            document.getElementById(tableId).dispatchEvent(new CustomEvent("phr-table-select", {
                detail: {
                    data,
                    checked: checkbox.prop("checked"),
                    selected: $(this).hasClass("selected"),
                    row: this
                }
            }));
        });

        table.buttons().container().appendTo(`#${tableId}_wrapper .col-sm-6:eq(0)`);

        table.on('select', (e, dt, type, indexes) => {
            table.rows(indexes).nodes().to$().find("input:checkbox").prop("checked", true);
        });
        table.on('deselect', (e, dt, type, indexes) => {
            table.rows(indexes).nodes().to$().find("input:checkbox").prop("checked", false);
        });
    }

    $(`#datatablesToggleActive${tableId}, #datatablesToggleExpired${tableId}`).on("click", () => {
        table.draw();
    });

    return table;
}


/**
 * Ermittelt die Sortierspalte basierend auf Klasse 'tabledate' oder fallback.
 * @param {jQuery} tableSelector
 * @returns {number}
 */
function getOrderByColumn(tableSelector) {
    try {
        const id = tableSelector.attr("id");
        const index = $("#" + id + " tr .tabledate").index();
        if (index >= 0) return index;
    } catch (e) {
    }
    return 2; // Fallback
}

/**
 * Initialisiert Moment.js für DataTables
 */
function registerMomentDateTypes() {
    const formats = [
        "DD.MM.YYYY",
        "DD.MM.YYYY HH:mm",
        "DD.MM.YYYY | HH:mm",
        "DD.MM.YYYY | HH:mm:ss"
    ];
    formats.forEach(fmt => $.fn.dataTable.moment(fmt));
}

/**
 * Erstellt einen benutzerdefinierten Sortier-Typ für unklare Datumsangaben.
 */
function registerNullableDateSort() {
    $.fn.dataTable.ext.type.order['nullable-date-pre'] = function (data) {
        const div = document.createElement("div");
        div.innerHTML = data;
        data = div.innerText.trim();
        const m = moment(data, [
            "DD.MM.YYYY",
            "DD.MM.YYYY HH:mm",
            "DD.MM.YYYY | HH:mm",
            "DD.MM.YYYY | HH:mm:ss"
        ], true);
        return m.isValid() ? m.valueOf() : null;
    };
}

/**
 * Ermittelt die Indizes der Spalten, die Datumswerte enthalten.
 * @param {jQuery} tableSelector
 * @returns {number[]}
 */
function detectDateColumns(tableSelector) {
    const formats = [
        "DD.MM.YYYY",
        "DD.MM.YYYY HH:mm",
        "DD.MM.YYYY | HH:mm",
        "DD.MM.YYYY | HH:mm:ss"
    ];
    const columns = [];
    tableSelector.find('thead th').each((index) => {
        const hasDate = tableSelector
            .find(`tbody tr td:nth-child(${index + 1})`)
            .toArray()
            .some(td => moment($(td).text().trim(), formats, true).isValid());
        if (hasDate) columns.push(index);
    });
    return columns;
}

/**
 * Fügt rückwärts nummerierte Zeilennummern hinzu (nur für appointmentsTable).
 * @param {DataTable.Api} api
 * @param {string} tableId
 */
function addRowNumbers(api, tableId) {
    if (tableId !== "appointmentsTable") return;
    const info = api.page.info();
    const total = info.recordsDisplay;
    api.column(0, {page: 'current'}).nodes().each((cell, i) => {
        cell.innerHTML = total - (info.start + i);
    });
}


/**
 * Initialisiert alle Tabellen mit der Klasse `.datatable` automatisch als DataTables.
 */
function datatableUs() {
    $(".datatable").each((_, table) => {
        const $table = $(table);
        const tableId = $table.attr("id");

        if (!tableId) {
            console.warn("Tabelle ohne ID gefunden. Wird übersprungen.");
            return;
        }

        let orderByColumn = undefined;
        const sortByEl = $table.find("tr .sort_by");
        if (sortByEl.length > 0) {
            orderByColumn = sortByEl.index();
        }

        datatableMe(tableId, false, orderByColumn);
    });
}

/**
 * Löscht gespeicherte DataTables-Zustände im localStorage.
 */
function clearDatatablesData() {
    const key = "MAODataTables";
    localStorage.removeItem(key);

    if (localStorage.getItem(key) === null) {
        console.log(`DataTables-Zustände unter '${key}' erfolgreich gelöscht.`);
    } else {
        console.warn(`Fehler beim Löschen von '${key}' aus localStorage.`);
    }
}

/**
 * Gibt den jQuery-Wrapper der DataTable für eine gegebene ID zurück.
 *
 * @param {string} tableId - ID der Tabelle.
 * @returns {jQuery} - Wrapper-Element der DataTable.
 */
function datatableWrapper(tableId) {
    if (!tableId) {
        console.warn("datatableWrapper: Keine tableId angegeben.");
        return $(); // leeres jQuery-Objekt
    }
    const $wrapper = $("#" + tableId).closest("div.dataTables_wrapper");
    if ($wrapper.length === 0) {
        console.warn(`Kein Wrapper für Tabelle mit ID '${tableId}' gefunden.`);
    }
    return $wrapper;
}


async function addTableListener(tableId) {
    const element = await waitForElm(tableId);
    const error = $(`#abs-diagnoses-selector`);

    element.addEventListener('phr-table-select', (event) => {

        const selectedRows = $("#" + event.currentTarget.id + " .selected");
        const diagnosesLongerThan = selectedRows.map(function () {
            const txt = $(this).find("td:eq(2)").text().trim();
            return txt.length > 100 ? txt : undefined; // Holt den Text aus der zweiten Zelle
        }).get();

        if (diagnosesLongerThan.length >= 1) {
            error.show();
            const errorText = error.children(".abs-error")
            errorText.html("Eine Diagnose darf maximal 100 Zeichen haben !");
        } else error.hide();

    });
}